export class DealerSummary {

    public id : string = '';

    public name : string = '';

    public city : string = '';

    public state : string = '';
}
